import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { addToArray } from '../../utils/immutable';
import Accordion from '../Accordion';

class AccordionGroup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false
    };
  }

  storeInput = title => {
    if (title && (!this.props.input || !this.props.input.includes(title))) {
      const new_input = addToArray(this.props.input, title);
      this.props.onInput(new_input);
      if (new_input.length === this.props.data.length) {
        this.props.onCompletion();
      }
    }
  };

  onToggle = (open, index) => {
    if (this.state.open === index) {
      this.setState({
        open: false
      });
    } else if (open) {
      const title = this.props.data[index].title;
      this.storeInput(title);
      this.setState({
        open: index
      });
    }
  };

  render() {
    return (
      <Fragment>
        {this.props.data.map((item, index) => {
          return (
            <Accordion
              key={index}
              data={item}
              index={index}
              closeAllButIndex={this.state.open}
              onToggle={this.onToggle}
            />
          );
        })}
      </Fragment>
    );
  }
}

AccordionGroup.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default AccordionGroup;



// WEBPACK FOOTER //
// ../core/src/components/AccordionGroup/AccordionGroup.js